import { EnhancedFormModel } from "@cakemail-org/ui-components-v2"

export function buildFromScript({ form }: { form?: EnhancedFormModel }) {
    if (!form || !form.published_url) {
        return "Form not published yet. Please publish the form first."
    }

    return `
<script id="form-${form.id}">
(function() {
    // Change 'null' to match your container element ID if you want the form
    // to appear inside a specific element. 
    // If you leave this as null, the form will simply be inserted
    // right before this <script> tag in your page.
    var FORM_CONTAINER_ID = null; 
    
    var script = document.getElementById('form-${form.id}');
    function insertContent(content) {
        if (FORM_CONTAINER_ID) {
            var container = document.getElementById(FORM_CONTAINER_ID);
            if (container) {
                container.innerHTML += content;
                return;
            }
            console.error('Container "' + FORM_CONTAINER_ID + '" not found');
            return;
        }
        
        var div = document.createElement('div');
        div.innerHTML = content;
        (script && script.parentNode) ? script.parentNode.insertBefore(div, script) : document.body.appendChild(div);
    }
    
    fetch('${form.published_url}')
        .then(response => response.text())
        .then(html => {
            insertContent(html);
            if (script) script.remove();
        })
        .catch(error => {
            insertContent('<p style="color: #666;">Form could not be loaded. Please try again later.</p>');
            console.error('Error loading form:', error);
            if (script) script.remove();
        });
})();
</script>`
}